<template>
  <div class="review__author">
    <p :class="{'text-xs leading-4': isTopReview}">
      <span
        v-if="showSchema"
        :itemprop="SCHEMA_ITEM_PROP.AUTHOR"
        itemscope
        :itemtype="SCHEMA_ITEM_TYPE.PERSON"
      >
        <strong
          :itemprop="SCHEMA_ITEM_PROP.NAME"
        >{{ reviewAuthor }}</strong>
      </span>
      <span v-else>
        <strong>{{ reviewAuthor }}</strong>
      </span>
      <span
        class="lg:block"
        :class="{'mt-1': isTopReview}"
      >{{ timeAgo }}</span>
      <span
        v-if="source"
        class="block text-sm mt-2 lg:mb-0 mb-3"
      >{{ source }}</span>
    </p>
  </div>
</template>
<script lang="ts">

import { SCHEMA_ITEM_TYPE, SCHEMA_ITEM_PROP } from '~~/constants/seo';

export default defineComponent({
  name: 'ReviewAuthor',
  props: {
    author: {
      type: String,
      default: '',
    },
    timeAgo: {
      type: String,
      required: true,
    },
    source: {
      type: String,
      default: '',
    },
    isTopReview: {
      type: Boolean,
      default: false,
    },
    showSchema: {
      type: Boolean,
      default: true,
    },
  },
  setup (props) {

    const i18n = useI18n();
    const reviewAuthor = computed(() => props.author || i18n.t('Anonymous'));

    return {
      reviewAuthor,
      SCHEMA_ITEM_TYPE,
      SCHEMA_ITEM_PROP,
    };
  
  },
});

</script>
